import { useQuery } from "@tanstack/react-query";
import { salesDb } from "@/integrations/supabase/sales-client";

export type EventRow = {
  id: string;
  name: string;
  description: string | null;
  location: string | null;
  start_at: string;
  end_at: string | null;
  created_at: string;
  deleted_at: string | null;
};

export const useEvents = (search: string = "") => {
  return useQuery({
    queryKey: ["sales-events", search],
    queryFn: async () => {
      let q = salesDb()
        .from("events")
        .select("id,name,description,location,start_at,end_at,created_at,deleted_at")
        .is("deleted_at", null)
        .order("start_at", { ascending: false });
      if (search.trim()) {
        const s = `%${search.trim()}%`;
        q = q.or(`name.ilike.${s},location.ilike.${s},description.ilike.${s}`);
      }
      const { data, error } = await q;
      if (error) throw error;
      return (data ?? []) as EventRow[];
    },
  });
};
